/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Pausereasons1Inputs */

const en_nav_pausereasons1 = /** @type {(inputs: Nav_Pausereasons1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause Reasons`)
};

const de_nav_pausereasons1 = /** @type {(inputs: Nav_Pausereasons1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausegründe`)
};

/**
* | output |
* | --- |
* | "Pause Reasons" |
*
* @param {Nav_Pausereasons1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const nav_pausereasons1 = /** @type {((inputs?: Nav_Pausereasons1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Pausereasons1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_pausereasons1(inputs)
	return de_nav_pausereasons1(inputs)
});
export { nav_pausereasons1 as "nav_pauseReasons" }